<div class="auth-page" role="main" aria-label="Register password page">
    <div class="auth-card-wrapper">
        <div class="auth-card">
            <div class="auth-form-wrapper form-section">
                <h3 [appTranslate]="'REGISTER'"></h3>

                <div class="form-group">
                    <label for="register-password-email" [appTranslate]="'EMAIL'"></label>
                    <input id="register-password-email" type="email" class="form-control" name="email" [(ngModel)]="registerPassModel.Email"
                        aria-describedby="register-password-email-errors">
                    <div id="register-password-email-errors" class="errors error-messages" *ngIf="errors">
                        <app-error [errors]="errors" [ErrorKey]="'Email'" class="error-feedback"></app-error>
                    </div>
                </div>

                <div class="form-group">
                    <label for="register-password-code" [appTranslate]="'CODE'"></label>
                    <input id="register-password-code" type="text" class="form-control" name="code" [(ngModel)]="registerPassModel.Code"
                        aria-describedby="register-password-code-errors">
                    <div id="register-password-code-errors" class="errors error-messages" *ngIf="errors">
                        <app-error [errors]="errors" [ErrorKey]="'Code'" class="error-feedback"></app-error>
                    </div>
                </div>

                <div class="loginBtn" *ngIf="!success">
                    <div class="form-actions">
                        <button type="button" class="btn-primary" (click)="registerPassword()"><span
                                [appTranslate]="'CONFIRM'"></span>
                        </button>
                    </div>
                </div>

                <div class="errors error-messages errorReason" *ngIf="errors">
                    <app-error [errors]="errors" [ErrorKey]="''" class="mainErrorReason"></app-error>
                </div>

                <div *ngIf="success" class="success-message">
                    <span [appTranslate]="'SUCCESS_VERIFY'"></span>
                    <button type="button" (click)="redirect()" [appTranslate]="'TO_LOGIN'" aria-label="Go to login"></button>
                </div>
            </div>
        </div>
    </div>
</div>